// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import FolderTreeList2 from './FolderTreeList2';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import FolderAddDialog from './FolderAddDialog';
import FolderPermissionEditDialog from './FolderPermissionEditDialog';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SendIcon from '@mui/icons-material/Send';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ConfirmDialog from './ConfirmDialog';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SelMemberDialog from './SelMemberDialog';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import dayjs from "dayjs"

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';



export default function FolderPermissionTab(props) {
  const { sysID, onUpdate } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const curDept = gState?.depts?.find(d => d.DeptCode == sysID);
  const adminLevel = curDept?.AdminLevel || 0;
  const isDataAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData);
  const isSecurtyAdmin = ((adminLevel & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  // const [folders, setFolders] = useState([]);
  // const [selFolderID, setSelFolderID] = useState(DmsCommon.VOID_FOLDER_ID)
  const [folderState, setFolderState] = useState({
    folders: [],
    selFolderID: DmsCommon.VOID_FOLDER_ID,
  });

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  useEffect(() => {
    // console.log("useEffect FolderPermissionTab(did mounted)");
    refreshData();
  }, []);



  // useEffect(() => {
  //   console.log("useEffect FolderPermissionTab[selFolderID]", folderState.selFolderID);

  //   onFolderIDChange(folderState.selFolderID);

  // }, [folderState.selFolderID]);


  const [isNormalFolder, setIsNormalFolder] = useState(false);
  const [inheritable, setInheritable] = useState(false);
  const [inherited, setInherited] = useState(false);

  const onFolderIDChange = async (aFolderID) => {
    // console.log("onFolderIDChange");

    const vIsNormalFolder = ![DmsCommon.VOID_FOLDER_ID, DmsCommon.ALL_FOLDER_ID, DmsCommon.PERSONAL_FOLDER_ID].includes(aFolderID);
    setIsNormalFolder(vIsNormalFolder);


    const vSelFolder = folderState.folders.find(f => f.id == aFolderID);
    const vIsRootChildFolder = vSelFolder && [DmsCommon.ALL_FOLDER_ID, DmsCommon.PERSONAL_FOLDER_ID].includes(vSelFolder.ParentID);

    const vIsInheritable = vIsNormalFolder && (!vIsRootChildFolder)
    setInheritable(vIsInheritable);

    setShowLoading(true);

    try {
      const [vRights, vInherited] = await DmsService.folderRightGetPromise(gState.sessionID, sysID, aFolderID, '');
      // console.log("vRights", vRights);
      // console.log("vInherited", vInherited);

      setShowLoading(false);

      const vData = vRights.map(item => {

        // const vDisplay = (item.IsUser ? item.Name : `[${item.Name}]`);

        return {
          ...item,
          // NameForDisplay: vDisplay,
          GradeForDisplay: DmsCommon.AccessRightEnumToStr(item.Grade),
        }
      });

      setGridData(vData);
      setInherited(vInherited);


    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);

      onCatchPromiseError(e);
    }
  }

  const [limitedRootFolderIDs, setLimitedRootFolderIDs] = useState(null);

  const refreshData = async (aSelFolderID) => {
    // console.log("FolderPermissionTab refreshData");


    setShowLoading(true);

    try {
      const [vRstFolders, vAdminFolders] = await Promise.all([
        DmsService.logIfLongRunningGetFoldersPromise(gState.sessionID, sysID, true),
        DmsService.getAdminFolderByUserPromise(gState.sessionID, sysID),
      ]);
      // console.log("vAdminFolders", vAdminFolders);

      setShowLoading(false);

      let vFolders = vRstFolders;

      // Do it when user is not security admin
      if (isSecurtyAdmin === false) {

        // Remove all shared Folder which is not created by user
        vFolders = vRstFolders.filter(item => {
          return (item.LinkedFolderID == 0 || item.CreatedBy == gState.userID);
        })
      }

      // console.log("isDataAdmin", isDataAdmin);

      if (isDataAdmin === true) {
        setLimitedRootFolderIDs(null);
      } else {
        const vAdminFolderIDs = vAdminFolders.map(f => f.FolderID);
        // console.log("vAdminFolderIDs", vAdminFolderIDs);
        setLimitedRootFolderIDs(vAdminFolderIDs);
      }

      if (aSelFolderID) {
        // setFolderState({...folderState, folders: vFolders, selFolderID: aSelFolderID});
        setFolderState((prevState) => { return { ...prevState, folders: vFolders, selFolderID: aSelFolderID } });
      } else {
        // setFolderState({...folderState, folders: vFolders});
        setFolderState((prevState) => { return { ...prevState, folders: vFolders } });
      }

    } catch (e) {
      setShowLoading(false);

      // setFolders([]);
      // setFolderState({...folderState, folders: []})
      setFolderState((prevState) => { return { ...prevState, folders: [] } });


      // console.log('Fail: ', e);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    }


  }


  const handleChangeFolderID = (AFolderID) => {
    // console.log("handleChangeFolderID", AFolderID);

    // setSelFolderID(AFolderID);
    // setFolderState({ ...folderState, selFolderID: AFolderID });
    setFolderState((prevState) => { return { ...prevState, selFolderID: AFolderID } });
    onFolderIDChange(AFolderID);
  }


  const handlePermissionUpdated = () => {
    setOpenPermEditDialog(false);
    onFolderIDChange(folderState.selFolderID);

    onUpdate && onUpdate();
  }

  const [gridData, setGridData] = useState([]);

  const [openPermEditDialog, setOpenPermEditDialog] = useState(false);

  const handleEditClick = () => {
    setOpenPermEditDialog(true);
  }


  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  // const GradeCellRenderer = (params) => {
  //   // console.log("gradeCellRenderer", params);

  //   const vGrade = params.value;
  //   const vGradeDesc = DmsCommon.AccessRightEnumToStr(vGrade);

  //   return vGradeDesc;
  // };

  const UserTypeRenderer = (params) => {
    return (

      <IconButton color="primary" aria-label="upload picture" component="span">
        {params.value === true && <AccountCircleIcon />}
        {params.value !== true && <GroupIcon />}
      </IconButton>
    )
  }


  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Name, nodeB.data.Name)
  }


  const columnDefs = useMemo(() => [
    { field: 'IsUser', headerName: " ", cellStyle: cellStyle, width: 50, cellRenderer: UserTypeRenderer, },
    { field: 'Name', headerName: "Group/User Name", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorName, },
    { field: 'GradeForDisplay', headerName: "Access Right", cellStyle: cellStyle, minWidth: 150, flex: "1", },
  ], []);



  return (
    <Box sx={{
      display: 'flex', flexDirection: 'row',
      height: "70vh",
    }} >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />


      <FolderPermissionEditDialog
        open={openPermEditDialog}
        onClose={() => { setOpenPermEditDialog(false) }}
        sysID={sysID}
        folders={folderState.folders}
        folderID={folderState.selFolderID}
        rights={gridData}
        inherited={inherited}
        inheritable={inheritable}
        afterUpdate={handlePermissionUpdated}
      />


      <div className="ag-theme-material" style={{ width: '50%', height: '100%' }}>

        <Box sx={{ display: 'flex', p: 0, height: 1, maxHeight: 1, overflow: 'auto' }} >
          <FolderTreeList2
            folders={folderState.folders}
            limitedRootFolderIDs={limitedRootFolderIDs}
            selFolderID={folderState.selFolderID}
            onChangeFolderID={handleChangeFolderID}
            disableAllFolder={!isDataAdmin}
            disablePersonalFolder={!isDataAdmin}
            disableReadCnt
          />

        </Box>

      </div>

      <Box sx={{ display: isNormalFolder ? "flex" : "none", flexDirection: 'column', width: 0.5, height: 1, m: 1 }} >
        <Box sx={{ py: 1, px: 1 }} >

          <Button disabled={folderState.selFolderID == DmsCommon.VOID_FOLDER_ID} startIcon={<EditIcon />} onClick={handleEditClick} >
            Edit
          </Button>

        </Box>

        {inheritable && inherited &&
          <Alert severity="info" sx={{ mb: 1 }} >Inherit permissions from parent folder</Alert>
        }

        <Box sx={{ width: 1, flex: 1, minHeight: 0 }} >

          <div className="ag-theme-material" style={{ width: '100%', height: '100%', }}>
            <AgGridReact

              rowData={gridData}

              defaultColDef={{
                width: 100,
                resizable: true,
                sortable: true,
                suppressMovable: true,
              }}
              columnDefs={columnDefs}
              headerHeight={40}

              suppressNoRowsOverlay

            />
          </div>
        </Box>

      </Box>

    </Box>


  );
}

FolderPermissionTab.propTypes = {
  sysID: PropTypes.string,
  onUpdate: PropTypes.func,
};
